import { on } from 'js/lib/events'
import { once } from 'js/lib/events'

// TODO - manually building the component markup is a little crufty and it would be better for us
// to use html templates to produce the same result

export function flash(type, message) {
  const $container = $('<div>', {
    class: 'c-flash js-c-flash component',
  })
  let $flash

  $container.appendTo($('#site-wrapper'))

  $flash = $('<div>', {
    class: `c-flash__container js-c-flash__conatainer c-flash__container--${type}`,
  }).append(
    $('<p>', {
      class: 'c-flash__message',
      text: message,
    })
  )

  if (type == 'notice') {
    const $counterElement = $('<div>', {
      class: 'c-flash__countdown js-c-flash__countdown js-c-flash__close',
      html: 'Closing message in <span class="js-c-flash__countdown__counter">5</span><i class="fa fa-times"></i>',
      data: { counter: 5 },
    })

    $flash.append($counterElement)
    initFlashCounter($counterElement)
  }

  if (type == 'alert') {
    $flash.append(
      $('<div>', {
        class: 'c-flash__close js-c-flash__close',
        html: 'Got it! Close this.',
      })
    )
  }

  $flash.appendTo($container)
}

on('click', '.js-c-flash__close', event => {
  const $flash = $(event.target).parents('.js-c-flash')

  $flash.fadeOut(() => {
    $flash.remove()
  })
})

$(document).ready(() => {
  const $countdown = $('.js-c-flash__countdown')

  if ($countdown.length === 0) return

  initFlashCounter($countdown)
})

async function initFlashCounter($element) {
  const $flashContainer = $element.parents('.js-c-flash')
  const $counterElement = $element.find('.js-c-flash__countdown__counter')
  let counter = $element.data('counter')
  const interval = setInterval(() => {
    $counterElement.text((counter -= 1))

    if (counter <= 0) {
      $element.trigger('click')
    }
  }, 1000)

  once('click', $element.get(0), () => {
    window.clearInterval(interval)

    $flashContainer.fadeOut(() => {
      $flashContainer.remove()
    })
  })
}
